module.exports = __webpack_public_path__ + "img/kPanel.1f128f8d.png";